import { EDruhCertifikatu } from 'enums/isin/udaje/druhCertifikatu';

const druhCertifikatuSelect = [
    {
        value: EDruhCertifikatu.PAKOVY,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_DRUH_PAKOVY'
    },
    {
        value: EDruhCertifikatu.NEPAKOVY,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_DRUH_NEPAKOVY'
    }
];

export default druhCertifikatuSelect;
